import SegmentPage from "@/pages/segments/SegmentPage";

export default function HighSchoolPage() {
  return (
    <SegmentPage
      testId="high-school-page"
      leadSegment="high_school"
      whitepaperLabel="High School Program Intelligence Whitepaper"
      eyebrow="For High School Programs"
      headline={<>Develop your program.</>}
      subhead={
        <>
          Stop juggling spreadsheets and disconnected technologies. ArmIQ gives every coach access to the same intelligence platform used by elite organizations — with a phone-first workflow your athletes will actually use.
        </>
      }
      tone="#22D3EE"
      focus={[
        "Simplicity",
        "Faster decisions",
        "Injury prevention",
        "Player development",
        "Practice organization",
      ]}
      outcomes={[
        { title: "Know who is ready — in seconds.", body: "Every athlete's four-pillar score in a single roster view. No spreadsheets. No group texts. Just the answer." },
        { title: "Better athlete availability.", body: "Predictive risk flags at-risk athletes before soft-tissue injuries force a full missed week." },
        { title: "Faster practice planning.", body: "Tomorrow's suggested hybrid track is pre-populated per athlete based on their readiness and workload." },
        { title: "Improved communication.", body: "One shared record between head coach, position coaches, and parents — no more information asymmetry." },
      ]}
    />
  );
}
